"use client";

// src/index.tsx
import React from "react";
var PlasmicDataSourceContext = React.createContext(void 0);
function usePlasmicDataSourceContext() {
  return React.useContext(PlasmicDataSourceContext);
}
function useCurrentUser() {
  var _a;
  const ctx = usePlasmicDataSourceContext();
  return (_a = ctx == null ? void 0 : ctx.user) != null ? _a : {
    isLoggedIn: false
  };
}
var PlasmicDataSourceContextProvider = PlasmicDataSourceContext.Provider;
export {
  PlasmicDataSourceContextProvider,
  useCurrentUser,
  usePlasmicDataSourceContext
};
